import toDate from '../to-date';

export const getStartOfDay = (dirtyDate: Date | number): Date => {
  const formattedDate = toDate(dirtyDate);

  formattedDate.setHours(0, 0, 0, 0);

  return formattedDate;
};

export default getStartOfDay;
